import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import FormLabel from '@mui/material/FormLabel'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Checkbox from '@mui/material/Checkbox'
import FormHelperText from '@mui/material/FormHelperText'
import Grid from '@mui/material/Grid'
import CardActions from '@mui/material/CardActions'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import { Alert, AlertTitle, Box, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Paper, Snackbar, Table, TableContainer, Typography } from '@mui/material'

// Integraciones externas disponibles (archivos en device/routes/api/*_ext).
// Mantener en sync si se agregan nuevos archivos de integracion.
const OPCIONES_VALIDAR_API  = ["walli"]
const OPCIONES_REPORTAR_API = ["flexipay", "uplifex", "walli"]

const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

class CajerosEditarPage extends Component {

    constructor(props) {
        super(props)

        this.idCajero = props.location.state.id_cajero
        this.entidadesSeleccionadas = []
        this.filtroFechaInicio = ""
        this.filtroFechaFin = ""

        this.state = {
          cajero: {},
          txtSerial: "",
          txtCodigo: "",
          txtAlias: "",
          txtDireccion: "",
          txtValidarApi: "",
          txtReportarApi: "",
          ticketPorUsuario: 0,
          mostrarResumenDeposito: "Si",
          txtEmailOperativo: "",
          txtEmailSeguridad: "",
          txtFranjaAutenticacion: "",
          txtContadorOffline1: 0,
          txtContadorOffline2: 0,
          txtKey1: "",
          txtKey2: "",
          txtKey3: "",
          txtKey4: "",
          txtKeyAlias: "",
          txtKeyValue: "",
          cmbCiudades: "",
          ciudades: [],
          entidades: [],
          entidadesDisponibles: [],
          entidadesCajero: [],
          keys: [],
          cantidad: 0,
          horaInicio: null,
          horaFin: null,
          horaInicio2: null,
          horaFin2: null,
          alertasLlenado: [],

          mostrarAlerta: false,
          mensajeAlerta: '',
          severidadAlerta: 'info',

          mostrarDialogo: false,
          selectedAlias: ''

          
        }

    }

    validarCorreos = (texto) => {
      if (!texto) return false;

      const correos = texto.split(';').map(c => c.trim()).filter(Boolean);

      if (correos.length === 0) return false;

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      return correos.every(c => emailRegex.test(c));
    };


    fechaFiltroChanged(origen, date) {
    if (date == null) return

    var formatoFechaInicio = "HH:mm:00"
    var formatoFechaFin = "HH:mm:00"

    switch (origen) {
      case 'inicio':
        this.setState({
          horaInicio: date,
          
        })
        this.horaInicio = date.toFormat(formatoFechaInicio)
        
        break;
      case 'inicio2':
        this.setState({       
          horaInicio2: date
        })
        this.horaInicio2 = date.toFormat(formatoFechaInicio)
        break;
      case 'fin':
        this.setState({
          horaFin: date,
          
        })
        this.horaFin = date.toFormat(formatoFechaFin)
        
        break;
        case 'fin2':
        this.setState({
          horaFin2: date
        })
        this.horaFin2 = date.toFormat(formatoFechaFin)
        break;
      default:

    }
  }

    handleChange = (event) => {
      this.setState({ cantidad: event.target.value });
    };

    onChangetxtSerial = (event) => {
      const serial = event.target.value.toString()
      this.setState({txtSerial: serial})
    }

    handleCloseAlert= (event, reason) => {
      if (reason === 'clickaway') {
        return; // Evitar que se cierre si el usuario hace clic fuera
      }
      this.setState({ mostrarAlerta: false })
    }
  

    onChangetxtCodigo = (event) => {
        const codigo = event.target.value.toString()
        this.setState({txtCodigo: codigo})
    }

    onChangetxtAlias = (event) => {
        const alias = event.target.value.toString()
        this.setState({txtAlias: alias})
    }

    onChangetxtDireccion = (event) => {
        const direccion = event.target.value.toString()
        this.setState({txtDireccion: direccion})
    }

    onChangetxtValidarApi = (event) => {
        const validarApi = event.target.value.toString()
        this.setState({txtValidarApi: validarApi})
    }

    onChangetxtReportarApi = (event) => {
        // Multi-select: value es un array -> se guarda como string separada por ';'
        const val = event.target.value
        const reportarApi = Array.isArray(val) ? val.filter(Boolean).join(';') : val.toString()
        this.setState({txtReportarApi: reportarApi})
    }

    onChangeTicketPorUsuario = (event) => {
        this.setState({ticketPorUsuario: parseInt(event.target.value, 10) || 0})
    }

    onChangeMostrarResumenDeposito = (event) => {
        this.setState({mostrarResumenDeposito: event.target.value})
    }

    onChangetxtEmailOperativo = (event) => {
      const value = event.target.value;
      this.setState({txtEmailOperativo: value});

      if (!this.validarCorreos(value)) {
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: 'Ingrese correo valido (Nota: use ; para separar)',
          severidadAlerta: 'warning'
        });
      }
    }

    onChangetxtEmailSeguridad = (event) => {
      const value = event.target.value;
      this.setState({txtEmailSeguridad: value});

      if (!this.validarCorreos(value)) {
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: 'Ingrese correo valido (Nota: use ; para separar)',
          severidadAlerta: 'warning'
        });
      }
    }


    onChangetxtFranjaAutenticacion = (event) => {
      const franjaAutenticacion = parseInt(event.target.value.toString())
      this.setState({txtFranjaAutenticacion: franjaAutenticacion})
    }
  
  onChangetxtContadorOffline1 = (event) => {
    const contadorOffline = parseInt(event.target.value.toString())
    this.setState({txtContadorOffline1: contadorOffline})
  }

  onChangetxtContadorOffline2 = (event) => {
    const contadorOffline = parseInt(event.target.value.toString())
    this.setState({txtContadorOffline2: contadorOffline})
  }

  onChangetxtKey1= (event) => {
    const key = event.target.value.toString()
    this.setState({txtKey1: key})
  }

  onChangetxtKey2= (event) => {
    const key = event.target.value.toString()
    this.setState({txtKey2: key})
  }

  onChangetxtKey3= (event) => {
    const key = event.target.value.toString()
    this.setState({txtKey3: key})
  }

  onChangetxtKey4= (event) => {
    const key = event.target.value.toString()
    this.setState({txtKey4: key})
  }

  onChangetxtKeyAlias = (event) => {
    const keyAlias = event.target.value.toString()
    this.setState({txtKeyAlias: keyAlias})
  }
  
  onChangetxtKeyValue = (event) => {
    const keyValue = event.target.value.toString()
    this.setState({txtKeyValue: keyValue})
  }

  onChangecmbCiudades = (event) => {
    const ciudad = event.target.value.toString()
    this.setState({cmbCiudades: ciudad})
  }

  // Niveles de llenado disponibles para configurar alertas (cada 10%).
  nivelesLlenado = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

  // Convierte el JSON guardado (alertas_llenado) a la forma editable del estado.
  parseAlertasLlenado = (value) => {
    let arr = [];
    try {
      arr = Array.isArray(value) ? value : JSON.parse(value || '[]');
    } catch (e) { arr = []; }
    if (!Array.isArray(arr)) arr = [];
    return arr
      .filter(a => a && a.nivel)
      .slice(0, 4)
      .map(a => ({
        nivel: Number(a.nivel),
        correos: Array.isArray(a.correos) ? a.correos.join('; ') : (a.correos || '')
      }));
  };

  // Niveles que aún se pueden elegir en una fila (excluye los usados por otras filas).
  nivelesDisponibles = (indexActual) => {
    const usados = this.state.alertasLlenado
      .map((a, i) => (i === indexActual ? null : Number(a.nivel)))
      .filter(Boolean);
    return this.nivelesLlenado.filter(n => !usados.includes(n));
  };

  agregarAlerta = () => {
    this.setState(prev => {
      if (prev.alertasLlenado.length >= 4) return null;
      return { alertasLlenado: [...prev.alertasLlenado, { nivel: '', correos: '' }] };
    });
  };

  quitarAlerta = (index) => {
    this.setState(prev => ({
      alertasLlenado: prev.alertasLlenado.filter((_, i) => i !== index)
    }));
  };

  cambiarAlertaNivel = (index, value) => {
    this.setState(prev => ({
      alertasLlenado: prev.alertasLlenado.map((a, i) => i === index ? { ...a, nivel: Number(value) } : a)
    }));
  };

  cambiarAlertaCorreos = (index, value) => {
    this.setState(prev => ({
      alertasLlenado: prev.alertasLlenado.map((a, i) => i === index ? { ...a, correos: value } : a)
    }));
  };

  normalizarEmails = (value) => {
    if (!value) return "";

    if (Array.isArray(value)) {
      return value.join('; ');
    }

    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.join('; ');
      }
    } catch (e) {}

    return value;
  };

  
  btnAgregarKey() {
	  var keys = this.state.keys
	  var alias = this.state.txtKeyAlias
	  var key = this.state.txtKeyValue

	  keys.push({
		  alias: alias,
		  key: key
	  })		
	  
	  this.setState({
		  keys: keys
	  })
	  
	  this.actualizarKeys()
	  
  }
  
  btnRandomKey() {
	  const genRanHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
	  
	  var key = genRanHex(16).toUpperCase()
	  
	  this.setState({
		  txtKeyValue: key
	  })
	  
  }
  
  handleDialogOpen = (alias) => {
    this.setState({
      mostrarDialogo: true,
      selectedAlias: alias 
    })
   }

  handleCloseDialog = () => {
    this.setState({
      mostrarDialogo: false,
      selectedAlias: '' 
    })
  }

  btnRemoverKey= () => {
    let alias = this.state.selectedAlias
    var updateKeys = this.state.keys.filter((key)=> key.alias !==  alias)

    this.setState(
      {
        keys: updateKeys,
        mostrarDialogo: false,
        selectedAlias: ''
    },
      ()=>{
        this.actualizarKeys()
      
      }
    )
  }

  actualizarEntidadesDisponibles() {
    var entidades = this.state.entidades
    
    var entidadesDisponibles = []
    var entidadesCajero = this.state.entidadesCajero

    entidades.forEach((entidad) => {
      var blnAgregar = true

      entidadesCajero.forEach((entidadCajero) => {
        if(entidadCajero.id === entidad.id) {
          blnAgregar = false
        }
      })

      if(blnAgregar) {
        entidadesDisponibles.push(entidad)
      }
    })
    
    /* entidades.map((entidad) => {
      var blnAgregar = true

      entidadesCajero.map((entidadCajero) => {
        if(entidadCajero.id == entidad.id) {
          blnAgregar = false
        }
      })

      if(blnAgregar) {
        entidadesDisponibles.push(entidad)
      }
    }) */

    this.setState({
      entidadesDisponibles: entidadesDisponibles
    })
  }

  agregarEntidad(idEntidad) {
    var entidadesDisponibles = this.state.entidadesDisponibles
    var entidadesCajero = this.state.entidadesCajero

    entidadesDisponibles.forEach((entidad) => {
      if(entidad.id === idEntidad) {
        entidadesCajero.push(entidad)
      }
    })

    /* entidadesDisponibles.map((entidad) => {
      if(entidad.id == idEntidad) {
        entidadesCajero.push(entidad)
      }
    }) */

    this.setState({
      entidadesCajero: entidadesCajero
    })

    this.actualizarEntidadesDisponibles()
  }

  removerEntidad(idEntidad) {
    var entidadesCajero = this.state.entidadesCajero
    for(var x = 0; x < entidadesCajero.length; x++) {
      if(entidadesCajero[x].id === idEntidad) {
        entidadesCajero.splice(x, 1) 
        break
      }
    }

    this.setState({
      entidadesCajero: entidadesCajero
    })

    this.actualizarEntidadesDisponibles()
  }

    componentDidMount() {
        this.queryCajero()
        this.queryCiudades()
        this.queryEntidades()
        this.queryEntidadesCajero()
    }

    btnActualizarCajeroClick = () => {
        console.log('Actualizando cajero....')

        var continuar = true
        var mensajeError = "Error:\n"

        const {txtEmailOperativo, txtEmailSeguridad} = this.state;

        if (
        !this.validarCorreos(txtEmailOperativo)||
        !this.validarCorreos(txtEmailSeguridad)
        ) {
          this.setState({
            mostrarAlerta: true,
            mensajeAlerta: 'Ingrese correos válidos separados por ;',
            severidadAlerta: 'warning'
          });
          return;
        }

        var serial = this.state.txtSerial
        var codigo = this.state.txtCodigo
        var alias = this.state.txtAlias
        var idCiudad = this.state.cmbCiudades
        var direccion = this.state.txtDireccion
        var franjaAutenticacion = this.state.txtFranjaAutenticacion
        var contadorOffline1 = this.state.txtContadorOffline1
        var contadorOffline2 = this.state.txtContadorOffline2



        serial = serial.trim()
        codigo = codigo.trim()
        alias = alias.trim()
        direccion = direccion.trim()
        franjaAutenticacion = parseInt(franjaAutenticacion)
        contadorOffline1 = parseInt(contadorOffline1)
        contadorOffline2 = parseInt(contadorOffline2)


        if(serial === '') {
          continuar = false
          mensajeError += " * Debe ingresar el serial.\n"
        }

        if(codigo === '') {
          continuar = false
          mensajeError += " * Debe ingresar el código.\n"
        }

        if(alias === '') {
          continuar = false
          mensajeError += " * Debe ingresar el alias.\n"
        }

        if(idCiudad < 1) {
          continuar = false
          mensajeError += " * Debe seleccionar la ciudad.\n"
        }

        if(direccion === '') {
          continuar = false
          mensajeError += " * Debe ingresar la dirección/ubicación.\n"
        }

        
        if(franjaAutenticacion < 1) {
          continuar = false
          mensajeError += " * Debe ingresar la franja de autenticación.\n"
        }

        if(contadorOffline1 < 0) {
          continuar = false
          mensajeError += " * Debe ingresar el contador offline 1.\n"
        }

        if(contadorOffline2 < 0) {
          continuar = false
          mensajeError += " * Debe ingresar el contador offline 2.\n"
        }

    
        if(continuar) {
			
			var restArgs = {
		      method: 'PATCH',
		      headers: 'JSON',
		      body: {
				  id_cajero: this.state.cajero.id,
	                serial: serial,
	                codigo: codigo,
	                alias: alias,
                  email_operativo: txtEmailOperativo,
                  email_seguridad: txtEmailSeguridad,
	                id_ciudad: idCiudad,
	                direccion: direccion,
	                validar_api_depositante: this.state.txtValidarApi.trim(),
	                reportar_api_transaccion: this.state.txtReportarApi.trim(),
	                ticket_por_usuario: this.state.ticketPorUsuario,
	                mostrar_resumen_deposito: this.state.mostrarResumenDeposito,
	                franja_autenticacion: franjaAutenticacion,
	                contador_offline1: contadorOffline1,
	                contador_offline2: contadorOffline2,
			  },
		      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/cajero/edit'
		    }
		
		    RestTunel.makePetition(restArgs,(err, data) => {
		      if(err) {
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Error actualizando cajero',
              severidadAlerta: 'error'
            })
          } else {
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Cajero Actualizado',
              severidadAlerta: 'success'
            })
		      }
		    })
	    }
    }

   
  btnGuardarEntidadesClick = () => {
    var entidadesCajero = this.state.entidadesCajero
    var entidades = []
    var mensajeError = "Error:\n"
    var continuar = true

    if(entidadesCajero.length < 1) {
      mensajeError += "* El cajero debe pertenecer al menos a una entidad."
      continuar = false
    } else {
      entidadesCajero.forEach((entidad) => {
        entidades.push(entidad.id)
      })

      /* entidadesCajero.map((entidad) => {
        entidades.push(entidad.id)
      })*/
    }
    
    if(continuar) {
		
		var restArgs = {
	      method: 'PATCH',
	      headers: 'JSON',
	      body: {
			  id_cajero: this.state.cajero.id,
              entidades: entidades
		  },
	      url: process.env.REACT_APP_URL_BACKEND +  '/cajeros/cajero/entidades'
	    }
	
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        //alert("Error actualizando entidades")
	        //console.log('Error respuesta consultando grupos')
          this.setState({
            mostrarAlerta: true,
            mensajeAlerta: 'Error actualizando entidades',
            severidadAlerta: 'error'
          })
	      } else {
	        //console.log('Entidades actualizadass')
	        //alert("Entidades actualizadas")
          this.setState({
            mostrarAlerta: true,
            mensajeAlerta: 'Entidades actualizadas',
            severidadAlerta: 'success'
          })
	      }
	    })
    }
  }

  

  cambiarEstado() {
      var estado = this.state.cajero.estado
      
      switch(estado) {
          case "I":
              estado = "A"
              break
          case "A":
              estado = "I"
              break
          default:
            break
      }

      console.log('Actualizando estado cajero....')
      
      var restArgs = {
	      method: 'PATCH',
	      headers: 'JSON',
	      body: {
			  id_cajero: this.idCajero,
	          estado: estado
		  },
	      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/cajero/estado/'
	    }
	
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        //alert("Error actualizando estado")
	        //console.log('Error respuesta actualizando estado cajero')
	        this.setState({
            grupos: [],
            mensajeError: data.message,
            mostrarAlerta: true,
            mensajeAlerta: 'Error actualizando estado',
            severidadAlerta: 'error'
            
	        })
	      } else {
	        // console.log('Estado cajero actualizado')
	      	// alert('Estado cajero actualizado')
	      	this.queryCajero()
          this.setState({
            mostrarAlerta: true,
            mensajeAlerta: 'Entidades cajero',
            severidadAlerta: 'success'
          })
	      }
	    })
      
    }
    
    actualizarKeys() {
      var keys = {
		  	keys: this.state.keys
		  }
      
      console.log('Actualizando keys cajero....')
      
      var restArgs = {
	      method: 'PATCH',
	      headers: 'JSON',
	      body: {
			  id_cajero: this.idCajero,
	          keys: keys
		  },
	      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/cajero/keys/'
	    }
	
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        //alert("Error actualizando keys")
	        // console.log('Error respuesta actualizando keys cajero')
	        this.setState({
				    mensajeError: data.message,

            mostrarAlerta: true,
            mensajeAlerta: 'Error actualizando key',
            severidadAlerta: 'error'
	        })
	      } else {
	        //console.log('Keys cajero actualizadas')
	        this.setState({
            txtKeyAlias: "",
            txtKeyValue: "",
            mostrarAlerta: true,
            mensajeAlerta: 'Keys cajero actualizadas',
            severidadAlerta: 'success'
	        })
	      	//alert('Keys cajero actualizadas')
	      	this.queryCajero()
	      }
	    })
      
    }

    queryCajero() {
        console.log('Consultando cajero....')
        
        var restArgs = {
	      method: 'POST',
	      headers: 'JSON',
	      body: {
		  	id_cajero: this.idCajero
		  },
	      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/detalle' 
	    }
	
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        //alert("Error consultando cajero")
	        // console.log('Error respuesta consultando cajero')
	        this.setState({
            cajero: {},
            mensajeError: data.message,

            mostrarAlerta: true,
            mensajeAlerta: 'Error consultando cajero',
            severidadAlerta: 'error'
	        })
	      } else {
	        //console.log('Cajero consultado')
	        
	        var keys = []
	        var keysByAlias = {}
	        try {
				var tempKeys = JSON.parse(data.keylist)
				keys = tempKeys.keys
				if (Array.isArray(keys)) {
					keys.forEach(k => { if (k && k.alias) keysByAlias[k.alias] = k.key })
				}
			} catch(error) {

			}


	      	this.setState({
                cajero: data,
                txtSerial: data.serial,
                txtCodigo: data.codigo,
                txtAlias: data.alias,
                cmbCiudades: data.ciudad,
                txtDireccion: data.direccion,
                txtValidarApi: data.validar_api_depositante || "",
                txtReportarApi: data.reportar_api_transaccion || "",
                ticketPorUsuario: (data.ticket_por_usuario != null ? parseInt(data.ticket_por_usuario, 10) : 0),
                mostrarResumenDeposito: (data.mostrar_resumen_deposito || "Si"),
                txtEmailOperativo: this.normalizarEmails(data.email_operativo),
                txtEmailSeguridad: this.normalizarEmails(data.email_seguridad),
                alertasLlenado: this.parseAlertasLlenado(data.alertas_llenado),
                txtFranjaAutenticacion: data.franja_autenticacion,
                txtContadorOffline1: data.contador_offline1,
                txtContadorOffline2: data.contador_offline2,
                keys: keys,
                txtKey1: keysByAlias.key1 || "",
                txtKey2: keysByAlias.key2 || "",
                txtKey3: keysByAlias.key3 || "",
                txtKey4: keysByAlias.key4 || ""
            })
	      }
	    })
    }

    queryCiudades() {
      console.log('Consultando ciudades....')
      
      var restArgs = {
	      method: 'POST',
	      headers: 'JSON',
	      body: {},
	      url: process.env.REACT_APP_URL_BACKEND + '/ciudades/'
	    }
	
	     RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        // alert("Error consultando ciudades")
	        // console.log('Error respuesta consultando ciudades')
	        this.setState({
            ciudades: [],
            mensajeError: data.message,

            mostrarAlerta: true,
            mensajeAlerta: 'Error consultando ciudades',
            severidadAlerta: 'error'
	        })
	      } else {
	        // console.log('Grupos consultados')
	      	this.setState({
	        	ciudades: data
	        })
	      }
	    })
      
   }

    queryEntidades() {
        //console.log('Consultando entidades....')
        
        var restArgs = {
	      method: 'POST',
	      headers: 'JSON',
	      body: {
		  },
	      url: process.env.REACT_APP_URL_BACKEND + '/entidades/usuario/list'
	    }
	
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        // alert("Error consultando grupos")
	        // console.log('Error respuesta consultando grupos')
	        this.setState({
            entidades: [],
            mensajeError: data.message,

            mostrarAlerta: true,
            mensajeAlerta: 'Error consultando grupos',
            severidadAlerta: 'error'
	        })
	      } else {
	        // console.log('Grupos consultados')
	      	this.setState({
	        	entidades: data
	        })
	        this.actualizarEntidadesDisponibles()
	      }
	    })
      }
	
	  queryEntidadesCajero() {
	    console.log('Consultando entidades cajero....')
	    var restArgs = {
	      method: 'POST',
	      headers: 'JSON',
	      body: {
			  id_cajero: this.idCajero
		  },
	      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/entidades/list'
	    }
	
	     RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        // alert("Error consultando entidades cajero")
	        // console.log('Error respuesta consultando entidades cajero')
	        this.setState({
            entidadesCajero: [],
            mensajeError: data.message,

            mostrarAlerta: true,
            mensajeAlerta: 'Error consultando entidades cajero',
            severidadAlerta: 'error'
	        })
	      } else {
	        // console.log('Entidades cajero consultadas')
	      	this.setState({
	        	entidadesCajero: data
	        })
	        this.actualizarEntidadesDisponibles()
	      }
	    })
	    
	  }

    btnActualizarCierreClick= () => {
      console.log('Actualizando cajero....')

      let {cantidad} = this.state;

      if(cantidad === 1){
        if(!this.horaInicio || !this.horaFin ) {
          this.setState({
            mostrarAlerta: true,
            mensajeAlerta: 'Por favor ingrese hora de cierre',
            severidadAlerta: 'warning'
          })
          return
        }
      }else if(cantidad === 2){
        if((!this.horaInicio || !this.horaFin) || (!this.horaInicio2 || !this.horaFin2)) {
          this.setState({
            mostrarAlerta: true,
            mensajeAlerta: 'Por favor ingrese informacion de ambos cierres',
            severidadAlerta: 'warning'
          })
          return
        }
      }
      
        var continuar = true

        var horaInicio = this.horaInicio
        var horaInicio2 = this.horaInicio2
        var horaFin = this.horaFin
        var horaFin2 = this.horaFin2

    
        if(continuar) {
			
			var restArgs = {
		      method: 'PATCH',
		      headers: 'JSON',
		      body: {
				  id_cajero: this.state.cajero.id,
	                cierre_inicio: horaInicio,
	                cierre_inicio2: horaInicio2,
	                cierre_fin: horaFin,
	                cierre_fin2: horaFin2,
			  },
		      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/cajero/cierre'
		    }
		
		    RestTunel.makePetition(restArgs,(err, data) => {
		      if(err) {
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Error actualizando cajero',
              severidadAlerta: 'error'
            })
          } else {
            this.setState({
              mostrarAlerta: true,
              mensajeAlerta: 'Cierres Actualizado',
              severidadAlerta: 'success'
            },()=>{this.btnLimpiarClick()})
		      }
		    })
	    }
    }

    btnLimpiarClick = () => {
      this.setState({
        horaInicio: null,
        horaFin: null,
        horaInicio2: null,
        horaFin2: null,
        cantidad: 0
      })
    }


    btnActualizarAlertasClick = () => {
      console.log('Actualizando Alertas....')

      const filas = this.state.alertasLlenado || [];

      // Validaciones: nivel elegido, sin niveles repetidos y correos válidos.
      const niveles = new Set();
      for (const fila of filas) {
        if (!fila.nivel) {
          this.setState({ mostrarAlerta: true, mensajeAlerta: 'Seleccione el nivel de llenado en todas las filas', severidadAlerta: 'warning' });
          return;
        }
        if (niveles.has(Number(fila.nivel))) {
          this.setState({ mostrarAlerta: true, mensajeAlerta: 'No se puede repetir el mismo nivel de llenado', severidadAlerta: 'warning' });
          return;
        }
        niveles.add(Number(fila.nivel));
        if (!String(fila.correos).trim() || !this.validarCorreos(fila.correos)) {
          this.setState({ mostrarAlerta: true, mensajeAlerta: 'Ingrese correos válidos (separados por ;) para el llenado al ' + fila.nivel + '%', severidadAlerta: 'warning' });
          return;
        }
      }

      const alertas_llenado = filas.map(f => ({
        nivel: Number(f.nivel),
        correos: String(f.correos).split(';').map(c => c.trim()).filter(Boolean)
      }));

      const restArgs = {
        method: 'PATCH',
        headers: 'JSON',
        body: {
          id_cajero: this.state.cajero.id,
          alertas_llenado: alertas_llenado,
        },
        url: process.env.REACT_APP_URL_BACKEND + '/cajeros/cajero/alerta'
      };

      RestTunel.makePetition(restArgs, (err, data) => {
        if (err) {
          this.setState({
            mostrarAlerta: true,
            mensajeAlerta: 'Error actualizando alertas',
            severidadAlerta: 'error'
          });
        } else {
          this.setState({
            mostrarAlerta: true,
            mensajeAlerta: 'Alertas actualizadas',
            severidadAlerta: 'success'
          });
        }
      });
    };


     btnLimpiarClickAlerta = () => {
      this.setState({ alertasLlenado: [] })
    }



    renderContenidoCondicional() {
    const { cantidad } = this.state;

    if (cantidad !== 1 && cantidad !== 2) {
      return null;
    }

    return (
      <Box sx={{ mt: 2 }}>
        <FormLabel sx={{ fontWeight: 600 }}>Cierre 1</FormLabel>
        <Grid container spacing={2} sx={{ mt: 0.5, mb: cantidad === 2 ? 2 : 0 }}>
          <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterLuxon}>
              <TimePicker
                inputFormat="HH:mm"
                label="Hora Inicio"
                value={this.state.horaInicio}
                onChange={date => this.fechaFiltroChanged('inicio', date)}
                renderInput={(params) => <TextField fullWidth size="small" {...params} />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterLuxon}>
              <TimePicker
                inputFormat="HH:mm"
                label="Hora fin"
                value={this.state.horaFin}
                onChange={date => this.fechaFiltroChanged('fin', date)}
                renderInput={(params) => <TextField fullWidth size="small" {...params} />}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>

        {cantidad === 2 && (
          <>
            <FormLabel sx={{ fontWeight: 600 }}>Cierre 2</FormLabel>
            <Grid container spacing={2} sx={{ mt: 0.5 }}>
              <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterLuxon}>
                  <TimePicker
                    inputFormat="HH:mm"
                    label="Hora Inicio"
                    value={this.state.horaInicio2}
                    onChange={date => this.fechaFiltroChanged('inicio2', date)}
                    renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterLuxon}>
                  <TimePicker
                    inputFormat="HH:mm"
                    label="Hora fin"
                    value={this.state.horaFin2}
                    onChange={date => this.fechaFiltroChanged('fin2', date)}
                    renderInput={(params) => <TextField fullWidth size="small" {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </>
        )}
      </Box>
    );
  }

  
  
    render() {
        var cajero = this.state.cajero
        const { mostrarDialogo, selectedAlias, keys } = this.state;
		
        return(
          <Box>
            <Typography gutterBottom variant="h5" component="div" sx={{ marginBottom: 2 }}>
              Editar Cajero
            </Typography>
            
            <Paper elevation={16}>
              <Grid >
                <Card>
                    <CardContent>
                        <form>
                            <FormLabel> Información cajero</FormLabel>
                            <Grid container spacing={2} rowSpacing={2} sx={{ marginTop: 1 }}>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <TextField
                                  label="Serial"
                                  id="outlined-basic"
                                  variant="outlined"
                                  value={this.state.txtSerial}
                                  onChange={this.onChangetxtSerial}
                                  InputProps={{ readOnly: true }}
                                  helperText="No editable"
                                  fullWidth
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <TextField
                                  label="Código"
                                  id="outlined-basic"
                                  variant="outlined"
                                  value={this.state.txtCodigo}
                                  onChange={this.onChangetxtCodigo}
                                  fullWidth
                                  />
                                </FormControl>
                              </Grid>   
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <TextField
                                  label="Alias"
                                  id="outlined-basic"
                                  variant="outlined"
                                  value={this.state.txtAlias}
                                  onChange={this.onChangetxtAlias}
                                  fullWidth
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <InputLabel>Ciudad</InputLabel>
                                  <Select
                                    label="Ciudad"
                                    value={this.state.cmbCiudades}
                                    defaultValue={0}
                                    onChange={this.onChangecmbCiudades}>
                                    <MenuItem value={0}>-- Seleccione ciudad --</MenuItem>
                                    {this.state.ciudades.map(ciudad => (
                                      <MenuItem value={ciudad.ciudad_id}>
                                      	<ListItemText primary={ciudad.ciudad_nombre}/>
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>     
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                    <TextField
                                    label="Dirección/Ubicación"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtDireccion}
                                    onChange={this.onChangetxtDireccion}
                                    fullWidth
                                  />
                               </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth>
                                    <InputLabel>Validar depositantes por API</InputLabel>
                                    <Select
                                      label="Validar depositantes por API"
                                      value={this.state.txtValidarApi}
                                      onChange={this.onChangetxtValidarApi}
                                    >
                                      <MenuItem value=""><em>— Validación local —</em></MenuItem>
                                      {OPCIONES_VALIDAR_API.map(op => (
                                        <MenuItem key={op} value={op}>{op}</MenuItem>
                                      ))}
                                    </Select>
                                    <FormHelperText>Vacío = validación local.</FormHelperText>
                               </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth>
                                    <InputLabel>Reportar transacción por API</InputLabel>
                                    <Select
                                      multiple
                                      label="Reportar transacción por API"
                                      value={this.state.txtReportarApi ? this.state.txtReportarApi.split(';').filter(Boolean) : []}
                                      onChange={this.onChangetxtReportarApi}
                                      renderValue={(selected) => selected.join(', ')}
                                    >
                                      {OPCIONES_REPORTAR_API.map(op => (
                                        <MenuItem key={op} value={op}>
                                          <Checkbox checked={(this.state.txtReportarApi || "").split(';').filter(Boolean).indexOf(op) > -1} />
                                          <ListItemText primary={op} />
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    <FormHelperText>Vacío = solo reporta a nuestro servidor. Puede elegir varios.</FormHelperText>
                               </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <InputLabel>Mostrar resumen de deposito</InputLabel>
                                  <Select
                                    label="Mostrar resumen de deposito"
                                    value={this.state.mostrarResumenDeposito}
                                    defaultValue={"Si"}
                                    onChange={this.onChangeMostrarResumenDeposito}>
                                    <MenuItem value={"Si"}>Si</MenuItem>
                                    <MenuItem value={"No"}>No</MenuItem>
                                  </Select>
                                  <FormHelperText>No = muestra "GRACIAS POR SU DEPOSITO" en vez del resumen.</FormHelperText>
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <InputLabel>Ticket por deposito</InputLabel>
                                  <Select
                                    label="Ticket por deposito"
                                    value={this.state.ticketPorUsuario}
                                    defaultValue={0}
                                    onChange={this.onChangeTicketPorUsuario}>
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                <TextField
                                  label="Correo Operativo"
                                  id="outlined-basic"
                                  variant="outlined"
                                  value={this.state.txtEmailOperativo}
                                  onChange={this.onChangetxtEmailOperativo}
                                  type='text'
                                  fullWidth
                                />
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                <TextField
                                  label="Correo Seguridad"
                                  id="outlined-basic"
                                  variant="outlined"
                                  value={this.state.txtEmailSeguridad}
                                  onChange={this.onChangetxtEmailSeguridad}
                                  type='text'
                                  fullWidth
                                />
                                </FormControl>
                              </Grid>
                              {/* <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                    <TextField
                                    label="Franja Autenticación"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtFranjaAutenticacion}
                                    onChange={this.onChangetxtFranjaAutenticacion}
                                    fullWidth
                                  />
                               </FormControl>
                              </Grid>  */}
                              {/* <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                    <TextField
                                    label="Contador Offline 1"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtContadorOffline1}
                                    onChange={this.onChangetxtContadorOffline1}
                                    fullWidth
                                  />
                               </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                    <TextField
                                    label="Contador Offline 2"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtContadorOffline2}
                                    onChange={this.onChangetxtContadorOffline2}
                                    fullWidth
                                  />
                               </FormControl>
                              </Grid> */}
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                    <TextField
                                    label="Key 1 (Des BD1)"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtKey1}
                                    onChange={this.onChangetxtKey1}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                    disabled
                                  />
                               </FormControl>
                              </Grid> 
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                    <TextField
                                    label="Key 2 (Des BD2)"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtKey2}
                                    onChange={this.onChangetxtKey2}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                    disabled
                                  />
                               </FormControl>
                              </Grid> 
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                    <TextField
                                    label="Key 3 (Autenticador)"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtKey3}
                                    onChange={this.onChangetxtKey3}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                    disabled
                                  />
                               </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                    <TextField
                                    label="Key 4 (Token cerradura)"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtKey4}
                                    onChange={this.onChangetxtKey4}
                                    fullWidth
                                    InputProps={{ readOnly: true }}
                                    disabled
                                  />
                               </FormControl>
                              </Grid>
                            </Grid>
                        </form>
                    </CardContent>
                    <CardActions>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Button  variant="contained" sx={{ marginBottom: 2 }} onClick={this.btnActualizarCajeroClick}>Actualizar Informacion Cajero</Button>
                        
                        <Snackbar
                              open={this.state.mostrarAlerta}
                              onClose={this.handleCloseAlert}
                              autoHideDuration={3000}
                              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                              >
                              <Collapse in={this.state.mostrarAlerta}>
                                <Alert
                                    severity={this.state.severidadAlerta}
                                    onClose={this.handleCloseAlert}
                                    sx={{ marginTop: 4, width:'100%'}}
                                    >
                                    <AlertTitle>
                                      {this.state.severidadAlerta.toUpperCase()}
                                    </AlertTitle>
                                    {this.state.mensajeAlerta}
                                </Alert>
                              </Collapse>
                          </Snackbar>
                      </Box>
                    </CardActions>
                  </Card>
              </Grid>
            </Paper>

            <br />

            <Grid container spacing={2} alignItems="stretch">
              <Grid item xs={12} md={6}>
                <Paper elevation={16} sx={{ height: '100%' }}>
                  <Card sx={{ height: '100%' }}>
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        Configurar cierres automáticos
                      </Typography>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        Define los horarios en que el cajero realiza el cierre automático.
                      </Typography>
                      <FormControl fullWidth size="small" sx={{ mt: 2, maxWidth: 280 }}>
                        <InputLabel>Cantidad de cierres</InputLabel>
                        <Select
                          label="Cantidad de cierres"
                          value={this.state.cantidad}
                          onChange={this.handleChange}
                        >
                          <MenuItem value={0}>Sin cierres</MenuItem>
                          <MenuItem value={1}>1 cierre</MenuItem>
                          <MenuItem value={2}>2 cierres</MenuItem>
                        </Select>
                      </FormControl>
                      {this.renderContenidoCondicional()}
                      <Box sx={{ mt: 2 }}>
                        <Button variant="contained" onClick={this.btnActualizarCierreClick}>
                          Actualizar cierres automáticos
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </Paper>
              </Grid>

              <Grid item xs={12} md={6}>
                <Paper elevation={16} sx={{ height: '100%' }}>
                  <Card sx={{ height: '100%' }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Configuración de alertas por llenado
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      Configura hasta 4 niveles de llenado y los correos que recibirán la alerta.
                    </Typography>

                    <Box sx={{ mt: 2 }}>
                      {this.state.alertasLlenado.length === 0 && (
                        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', mb: 2 }}>
                          No hay alertas configuradas. Agrega hasta 4 niveles de llenado.
                        </Typography>
                      )}

                      {this.state.alertasLlenado.map((fila, index) => (
                        <Grid container spacing={2} alignItems="center" key={index} sx={{ mb: 1.5 }}>
                          <Grid item xs={12} sm={3}>
                            <FormControl fullWidth size="small">
                              <InputLabel id={"nivel-label-" + index}>Nivel</InputLabel>
                              <Select
                                labelId={"nivel-label-" + index}
                                label="Nivel"
                                value={fila.nivel || ''}
                                onChange={(e) => this.cambiarAlertaNivel(index, e.target.value)}
                              >
                                {this.nivelesDisponibles(index).map(n => (
                                  <MenuItem key={n} value={n}>Llenado al {n}%</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={7}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Correos (separados por ;)"
                              placeholder="correo1@ejemplo.com;correo2@ejemplo.com"
                              value={fila.correos}
                              onChange={(e) => this.cambiarAlertaCorreos(index, e.target.value)}
                              type="text"
                            />
                          </Grid>
                          <Grid item xs={12} sm={2}>
                            <Button fullWidth color="error" variant="outlined" onClick={() => this.quitarAlerta(index)}>
                              Quitar
                            </Button>
                          </Grid>
                        </Grid>
                      ))}

                      <Box sx={{ display: 'flex', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                        <Button
                          variant="outlined"
                          onClick={this.agregarAlerta}
                          disabled={this.state.alertasLlenado.length >= 4}
                        >
                          {this.state.alertasLlenado.length >= 4 ? '+ Agregar nivel (máx. 4)' : '+ Agregar nivel'}
                        </Button>
                        <Button variant="contained" onClick={this.btnActualizarAlertasClick}>
                          Actualizar alertas automáticas
                        </Button>
                      </Box>
                    </Box>
                  </CardContent>
                  </Card>
                </Paper>
              </Grid>
            </Grid>

            <br />

            <Paper elevation={16}>
              <Grid xs={4}>
                      <Card>
                        <CardContent>
                          <Grid container spacing={2} columnSpacing={2}>
                            <Grid item xs={6}>
                              <FormLabel>Entidades Disponibles</FormLabel>
                              <List
                                sx={{
                                  minHeight: 300,
                                  maxHeight: 300,
                                  overflow: 'auto'
                                }}>
                                  {this.state.entidadesDisponibles.map((entidad) => {
                                      return(
                                        <ListItem button
                                          key={entidad.id} classes={{root: "ItemLista"}} onClick={() =>{this.agregarEntidad(entidad.id)}}>
                                            {entidad.nombre}
                                        </ListItem>
                                      )
                                    }
                                  )}
                              </List>
                            </Grid>
                            <Grid item xs={6}>
                              <FormLabel>Entidades Cajero</FormLabel>
                              <List
                                sx={{
                                  minHeight: 300,
                                  maxHeight: 300,
                                  overflow: 'auto'
                                }}>
                                  {this.state.entidadesCajero.map((entidad) => {
                                      return(
                                        <ListItem 
                                          key={entidad.id} classes={{root: "ItemLista"}} onClick={() =>{this.removerEntidad(entidad.id)}}>
                                          {entidad.nombre}
                                        </ListItem>
                                      )
                                    }
                                  )}
                              </List>
                            </Grid>
                          </Grid>
                        </CardContent>
                        <CardActions>
                          <Button variant="contained" fullWidth onClick={this.btnGuardarEntidadesClick}>Guardar Entidades</Button>
                        </CardActions>
                      </Card>
              </Grid>
              
            </Paper>
                               
				    <br />
{/*/----------------------------------------------------------------------------------------*/}
            {/* <Paper elevation={16}>
                   <Grid item xs={4} spacing={2}>
                   		<Card>
		                    <CardContent>
                          <TableContainer
                            sx={{
                              padding: 2, 
                              margin: 2,  
                            }}
                          >
                            <Table>
                              
                                {
                                  this.state.keys.map((item) => {
                                return(
                                  
                                  <tr>
                                    <td>{item.alias}: </td>
                                    
                                    <td>{item.key}</td>
                                    
                                    <td>
                                      <Button variant="contained" size='small' color="error" onClick={()=> this.handleDialogOpen(item.alias)}><DeleteIcon/></Button>

                                      
                                    </td>

                                  </tr>
                                )
                                  })
                                }
                              <Dialog
                                open={mostrarDialogo}
                                onClose={this.handleCloseDialog}
                                aria-labelledby="confirm-dialog-title"
                                aria-describedby="confirm-dialog-description"
                                //keepMounted
                                >
                                <DialogTitle id="confirm-dialog-title">
                                        {`¿Desea borrar la key "${selectedAlias}"? `}
                                </DialogTitle>
                      
                                <DialogContent>
                                          <DialogContentText id="alert-dialog-slide-description">
                                            Borrar esta key podra implicar perdida de informacion.
                                          </DialogContentText>
                                </DialogContent>
      
                                <DialogActions>
                                          <Button onClick={this.handleCloseDialog}>Cancelar</Button>
                                          <Button onClick={this.btnRemoverKey} autoFocus >Confirmar</Button>
                                </DialogActions>
                              </Dialog>
        
                            </Table>
                          </TableContainer>
							<CardActions>
								                  <TextField
                                    label="Alias"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtKeyAlias}
                                    onChange={this.onChangetxtKeyAlias}
                                    
                                  />
                                  <TextField
                                    label="Valor"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtKeyValue}
                                    onChange={this.onChangetxtKeyValue}
                                    sx={{ marginRight: 2 }}
                                  />
                                  <br />
                                  <Button variant="contained" size='small' color="success"  onClick={() => {this.btnRandomKey()}}><KeyIcon /></Button>
                                  <br />
                                  <Button variant="contained" size='small' color="primary" onClick={() => {this.btnAgregarKey()}}><SaveIcon /></Button>
							</CardActions>
		                    </CardContent>
                      </Card>
                   </Grid>
           

            </Paper> */}
 {session.checkPermiso('acceder_acciones_rapidas') && (
              <Card sx={{ mb: 3 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Acciones rápidas
                  </Typography>

                  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                   
                      <>
                        <Link
                          to={{
                            pathname: '/dashboard/cajeros/dispositivoscomplementos',
                            state: { id_cajero: cajero.id }
                          }}
                          style={{ textDecoration: 'none' }}
                        >
                          <Button variant="contained" color="primary">
                            Configurar Dispositivos y Complementos
                          </Button>
                        </Link>
                      </>



                    {session.checkPermiso('acceder_cajeros_acciones_remotas') && (
                      <Link
                        to={{
                          pathname: '/dashboard/cajeros/accionesremotas',
                          state: { id_cajero: cajero.id }
                        }}
                        style={{ textDecoration: 'none' }}
                      >
                        <Button variant="contained" color="primary">
                          ACCIONES
                        </Button>
                      </Link>
                    )}

                    {session.checkPermiso('opcion_desactivar_cajero') && (
                      <Button
                        variant="contained"
                        color={cajero.estado === "A" ? "error" : "success"}
                        onClick={() => this.cambiarEstado()}
                      >
                        {cajero.estado === "A" ? "Desactivar Cajero" : "Activar Cajero"}
                      </Button>
                    )}
                  </Box>
                </CardContent>
              </Card>
              )}
        </Box>
        )
    }

}


export default CajerosEditarPage